import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09653543"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shape-item-thumbnail" }
const _hoisted_2 = { class: "shape-content" }
const _hoisted_3 = {
  overflow: "visible",
  width: "18",
  height: "18"
}
const _hoisted_4 = ["transform"]
const _hoisted_5 = ["fill", "stroke", "d"]

import { PropType } from 'vue'
import { ShapePoolItem } from '@/configs/shapes'


export default /*#__PURE__*/_defineComponent({
  __name: 'ShapeItemThumbnail',
  props: {
  shape: {
    type: Object as PropType<ShapePoolItem>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock("svg", _hoisted_3, [
        _createElementVNode("g", {
          transform: `scale(${18 / __props.shape.viewBox[0]}, ${18 / __props.shape.viewBox[1]}) translate(0,0) matrix(1,0,0,1,0,0)`
        }, [
          _createElementVNode("path", {
            class: _normalizeClass(["shape-path", { 'outlined': __props.shape.outlined }]),
            "vector-effect": "non-scaling-stroke",
            "stroke-linecap": "butt",
            "stroke-miterlimit": "8",
            fill: __props.shape.outlined ? '#999' : 'transparent',
            stroke: __props.shape.outlined ? 'transparent' : '#999',
            "stroke-width": "2",
            d: __props.shape.path
          }, null, 10, _hoisted_5)
        ], 8, _hoisted_4)
      ]))
    ])
  ]))
}
}

})